<template>
    <np-skeleton v-if="!objectIsNotEmpty(merchant.business_entity)" :type="'full_view'"></np-skeleton>
    <div v-else>
        <form v-if="!is_signed" @submit.prevent="submitPrevent" id="bank_details_form"
              ref="bank_details_form" class="content-inner formValidation">
            <div class="row">
                <div class="col-12">
                    <div class="panel-sub-heading headingSmall">
                        <span class="h5 display-6 markedBottom bold">{{ lang('bank_details') }}</span>
                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-12">
                    <div class="row">
                        <div class="col-12">
                            <np-input :id="`bank_account_holder_name`"
                                      :name="`bank_account_holder_name`"
                                      :label="lang('account_holder_name')"
                                      :required="true"
                                      @input="validateBank(bank)"
                                      v-model="merchant.business_entity.banks[0].account_holder_name">
                            </np-input>
                            <np-input :id="`bank_sort_code`"
                                      :name="`bank_sort_code`"
                                      :label="lang('sort_code')"
                                      :rules="['integer']"
                                      :required="true"
                                      @input="validateBank(bank)"
                                      v-model="merchant.business_entity.banks[0].sort_code">
                            </np-input>
                            <np-input :id="`bank_account_number`"
                                      :name="`bank_account_number`"
                                      :label="lang('account_number')"
                                      :rules="['integer']"
                                      :required="true"
                                      @input="validateBank(merchant.business_entity.banks[0])"
                                      v-model="merchant.business_entity.banks[0].account_number">
                            </np-input>
                        </div>
<!--                        <div class="col-lg-6 col-md-6 col-12">-->
<!--                            <div class="card card__bank-address">-->
<!--                                &lt;!&ndash;                                   TODO get the height of the form div and make this card match or be horizontally centered.&ndash;&gt;-->
<!--                                <div class="card-body py-2">-->
<!--                                               <span>{{merchant.business_entity.banks[0].bank_name}} <br>{{merchant.business_entity.banks[0].street_line_1}} <br>-->
<!--                                                   {{`${merchant.business_entity.banks[0].bank_city},`}} {{`${merchant.business_entity.banks[0].county_code},`}}-->
<!--                                                   <br>{{`${merchant.business_entity.banks[0].zip_code},`}}-->
<!--                                                   <br> {{formatCountry(merchant.business_entity.banks[0].country_code)}}-->
<!--                                               </span>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
                <div class="col-12">
                    <div class="my-3">
                        <button class="btn btn-danger me-1" @click="backPage"> {{lang('go_back')}}</button>
                        <button class="btn btn-default me-1" @click="signBankAgreement"> {{lang('sign_agreement')}}</button>
                    </div>
                </div>
            </div>
        </form>
        <div v-else class="row mt-3">
            <div class="col-12">
                <h5 class="display-6">
                    <span class="bold">{{lang('your_reference_is')}}</span> : {{signed_reference}}
                </h5>
                <hr class="mt-1">
            </div>
            <div class="col-12">
                <h5 class="display-6 bold">{{lang('thank_you_for_submitting_your_application')}}</h5>
                <p>{{lang('to_complete_bank_application')}}</p>
                <ul>
                    <li v-for="(document, index) in tenantUploadCategories">{{getDocumentCategoryName(document.document_category_external_id)}}</li>
                </ul>
            </div>
            <div class="col-12">
                <h5 class="display-6 bold">{{lang('would_you_like_to_upload')}}</h5>
                <button class="btn btn-danger me-1" type="button" @click="notSubmit">{{lang('no')}}</button>
                <button class="btn btn-default me-1" type="button" @click="documentRoute">{{lang('yes')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker,
        NPInput,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat
    } from "netpify/components";
    import {BankDetails} from "../../../entities";

    export default {
        name: "BankDetails",
        mixins: [utilMixin, applicationMixin],
        components: {
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                bank: new BankDetails(),
                is_signed: false,
                signed_reference: '12345676543',
                page_label: 'securely_provide_your_bank_details',
                signed_label: 'your_application_has_been_submitted',
            }
        },
        metaInfo() {
            return {
                title: this.lang('bank_details')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.setAppPageTitle(vm.page_label))
        },
        computed: {
            tenantUploadCategories: function () {
                return this.parameters.hasOwnProperty('TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM') ?
                    this.parameters.TENANT_UPLOAD_DOCUMENT_CATEGORY_PARAM : [];
            }

        },
        methods: {
            getDocumentCategoryName: function (id) {
                let param = this.parameters.UPLOAD_DOCUMENT_CATEGORY_PARAM.find(obj => {
                    return obj.document_category_external_id === id
                })

                return !!param.category_name ? param.category_name : '';
            },
            documentRoute: function () {
                this.$router.push({path: `${this.application_root_path}documents/`});
            },
            validateBank: function (bank) {
                if (!!bank.sort_code && bank.account_number) {
                    //TODO validate and get account details.
                }
            },
            backPage: function () {
                this.$router.push({path: `${this.application_root_path}business_details`});
            },
            signBankAgreement: function () {
                this.is_signed = true;

                this.setAppPageTitle(this.signed_label);
            },
            notSubmit: function () {

            },
            submitApplication: function () {

            }
        }
    }
</script>

<style scoped>
    .card__bank-address {
        margin-top: 1.25rem;
    }
</style>
